import React from "react";

import { GalleryImg, TextImg, UploadImg } from "../../images";

const UploadOptions = ({ className, setSelected = () => {} }) => {
  return (
    <div className={"selectionToolSec"}>
      <div className={className || "selectionTool"}>
        <div
          className={"selectionToolItem"}
          onClick={() => {
            setSelected("gallery");
          }}
        >
          <img src={GalleryImg} alt="" />
          <p className="mb-0">Gallery</p>
        </div>
        <div
          className={"selectionToolItem"}
          onClick={() => {
            setSelected("device");
          }}
        >
          <img src={UploadImg} alt="" />
          <p className="mb-0">Upload</p>
        </div>
        <div
          className={"selectionToolItem"}
          onClick={() => {
            setSelected("text");
          }}
        >
          <img src={TextImg} alt="" />
          <p className="mb-0">Add Text</p>
        </div>
      </div>
    </div>
  );
};
export default UploadOptions;
